// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2ewA2","label":"Radio_label__U3Paz","checkMark":"Radio_checkMark__1TZWJ","disabled":"Radio_disabled__2sM8m"};